var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessability = function SvgAccessability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3451",
    stroke: "#2E3451",
    strokeWidth: 0.7,
    d: "M14 3.5C8.201 3.5 3.5 8.201 3.5 14S8.201 24.5 14 24.5 24.5 19.799 24.5 14C24.493 8.204 19.796 3.507 14 3.5zm0 20.3c-5.412 0-9.8-4.388-9.8-9.8 0-5.412 4.388-9.8 9.8-9.8 5.412 0 9.8 4.388 9.8 9.8-.006 5.41-4.39 9.794-9.8 9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3451",
    fillRule: "evenodd",
    d: "M14 11.099c1.127 0 2.04-.918 2.04-2.05A2.045 2.045 0 0 0 14 7c-1.126 0-2.04.918-2.04 2.05A2.048 2.048 0 0 0 14 11.099zm4.73.344h.005a1.024 1.024 0 0 1 .155 2.044l-2.88.262a.341.341 0 0 0-.31.34v.786c0 .17.032.34.094.498l1.642 4.201a1.027 1.027 0 0 1-.532 1.33c-.507.224-1.1 0-1.335-.504l-1.573-3.84-1.56 3.83c-.227.517-.83.751-1.345.522a1.027 1.027 0 0 1-.52-1.352l1.636-4.186c.062-.159.094-.328.094-.5v-.785a.342.342 0 0 0-.31-.34l-2.885-.263a1.024 1.024 0 0 1 .16-2.042l3.576.322c.121.01.243.016.364.016h1.589c.122 0 .243-.006.365-.017l3.57-.322z",
    clipRule: "evenodd"
  })));
};
export default SvgAccessability;